import type { ModuleMigrationDef } from "@kubdee/sdk";

export const migration: ModuleMigrationDef = {
  key: "001_initial",
  version: "1.0.0",
  sql: `
CREATE TABLE IF NOT EXISTS \`inventory_warehouses\` (
	\`id\` text PRIMARY KEY NOT NULL,
	\`company_id\` text NOT NULL,
	\`code\` text NOT NULL,
	\`name\` text NOT NULL,
	\`location\` text,
	\`is_default\` integer DEFAULT 0 NOT NULL,
	\`is_active\` integer DEFAULT 1 NOT NULL,
	\`created_by\` text,
	\`created_at\` text NOT NULL,
	\`updated_by\` text,
	\`updated_at\` text NOT NULL,
	\`deleted_by\` text,
	\`deleted_at\` text
);
CREATE INDEX IF NOT EXISTS \`wh_company_idx\` ON \`inventory_warehouses\` (\`company_id\`,\`is_active\`);
CREATE TABLE IF NOT EXISTS \`inventory_delivery_orders\` (
	\`id\` text PRIMARY KEY NOT NULL,
	\`company_id\` text NOT NULL,
	\`branch_id\` text,
	\`order_no\` text NOT NULL,
	\`party_type\` text DEFAULT 'customer' NOT NULL,
	\`party_id\` text NOT NULL,
	\`warehouse_id\` text NOT NULL,
	\`posting_date\` text NOT NULL,
	\`remarks\` text,
	\`doc_status\` integer DEFAULT 0 NOT NULL,
	\`reference_module\` text,
	\`reference_id\` text,
	\`total_qty\` real DEFAULT 0 NOT NULL,
	\`total_amount\` real DEFAULT 0 NOT NULL,
	\`created_by\` text,
	\`created_at\` text NOT NULL,
	\`updated_by\` text,
	\`updated_at\` text,
	\`deleted_by\` text,
	\`deleted_at\` text
);
CREATE UNIQUE INDEX IF NOT EXISTS \`delivery_orders_order_no_unique\` ON \`inventory_delivery_orders\` (\`order_no\`);
CREATE INDEX IF NOT EXISTS \`do_company_date_idx\` ON \`inventory_delivery_orders\` (\`company_id\`,\`posting_date\`);
CREATE INDEX IF NOT EXISTS \`do_company_party_idx\` ON \`inventory_delivery_orders\` (\`company_id\`,\`party_id\`);
CREATE TABLE IF NOT EXISTS \`inventory_delivery_order_items\` (
	\`id\` text PRIMARY KEY NOT NULL,
	\`delivery_order_id\` text NOT NULL,
	\`item_id\` text NOT NULL,
	\`warehouse_id\` text,
	\`qty\` real DEFAULT 0 NOT NULL,
	\`rate\` real DEFAULT 0 NOT NULL,
	\`amount\` real DEFAULT 0 NOT NULL,
	\`remarks\` text,
	FOREIGN KEY (\`delivery_order_id\`) REFERENCES \`inventory_delivery_orders\`(\`id\`) ON UPDATE no action ON DELETE no action
);
CREATE INDEX IF NOT EXISTS \`doi_delivery_order_idx\` ON \`inventory_delivery_order_items\` (\`delivery_order_id\`);
CREATE TABLE IF NOT EXISTS \`inventory_goods_receipts\` (
	\`id\` text PRIMARY KEY NOT NULL,
	\`company_id\` text NOT NULL,
	\`branch_id\` text,
	\`receipt_no\` text NOT NULL,
	\`party_type\` text DEFAULT 'supplier' NOT NULL,
	\`party_id\` text NOT NULL,
	\`warehouse_id\` text NOT NULL,
	\`posting_date\` text NOT NULL,
	\`remarks\` text,
	\`doc_status\` integer DEFAULT 0 NOT NULL,
	\`reference_module\` text,
	\`reference_id\` text,
	\`total_qty\` real DEFAULT 0 NOT NULL,
	\`total_amount\` real DEFAULT 0 NOT NULL,
	\`created_by\` text,
	\`created_at\` text NOT NULL,
	\`updated_by\` text,
	\`updated_at\` text,
	\`deleted_by\` text,
	\`deleted_at\` text
);
CREATE UNIQUE INDEX IF NOT EXISTS \`goods_receipts_receipt_no_unique\` ON \`inventory_goods_receipts\` (\`receipt_no\`);
CREATE INDEX IF NOT EXISTS \`gr_company_date_idx\` ON \`inventory_goods_receipts\` (\`company_id\`,\`posting_date\`);
CREATE INDEX IF NOT EXISTS \`gr_company_party_idx\` ON \`inventory_goods_receipts\` (\`company_id\`,\`party_id\`);
CREATE TABLE IF NOT EXISTS \`inventory_goods_receipt_items\` (
	\`id\` text PRIMARY KEY NOT NULL,
	\`goods_receipt_id\` text NOT NULL,
	\`item_id\` text NOT NULL,
	\`warehouse_id\` text,
	\`qty\` real DEFAULT 0 NOT NULL,
	\`rate\` real DEFAULT 0 NOT NULL,
	\`amount\` real DEFAULT 0 NOT NULL,
	\`remarks\` text
);
CREATE INDEX IF NOT EXISTS \`gri_receipt_idx\` ON \`inventory_goods_receipt_items\` (\`goods_receipt_id\`);
CREATE TABLE IF NOT EXISTS \`inventory_stock_entries\` (
	\`id\` text PRIMARY KEY NOT NULL,
	\`company_id\` text NOT NULL,
	\`entry_no\` text NOT NULL,
	\`item_id\` text NOT NULL,
	\`warehouse_id\` text NOT NULL,
	\`entry_type\` text NOT NULL,
	\`qty\` real NOT NULL,
	\`rate\` real DEFAULT 0 NOT NULL,
	\`amount\` real DEFAULT 0 NOT NULL,
	\`posting_date\` text NOT NULL,
	\`reference_module\` text,
	\`reference_id\` text,
	\`remarks\` text,
	\`created_by\` text,
	\`created_at\` text NOT NULL,
	\`updated_at\` text,
	\`updated_by\` text,
	\`deleted_by\` text,
	\`deleted_at\` text
);
CREATE UNIQUE INDEX IF NOT EXISTS \`stock_entries_entry_no_unique\` ON \`inventory_stock_entries\` (\`entry_no\`);
CREATE INDEX IF NOT EXISTS \`se_item_wh_idx\` ON \`inventory_stock_entries\` (\`item_id\`,\`warehouse_id\`,\`posting_date\`);
CREATE INDEX IF NOT EXISTS \`se_company_date_idx\` ON \`inventory_stock_entries\` (\`company_id\`,\`posting_date\`);
CREATE TABLE IF NOT EXISTS \`inventory_stock_ledger\` (
	\`id\` text PRIMARY KEY NOT NULL,
	\`company_id\` text NOT NULL,
	\`item_id\` text NOT NULL,
	\`warehouse_id\` text NOT NULL,
	\`current_qty\` real DEFAULT 0 NOT NULL,
	\`current_value\` real DEFAULT 0 NOT NULL,
	\`avg_rate\` real DEFAULT 0 NOT NULL,
	\`reorder_level\` real DEFAULT 0,
	\`created_at\` text,
	\`created_by\` text,
	\`updated_at\` text NOT NULL,
	\`updated_by\` text
);
CREATE UNIQUE INDEX IF NOT EXISTS \`sl_item_wh_idx\` ON \`inventory_stock_ledger\` (\`company_id\`,\`item_id\`,\`warehouse_id\`);
  `.trim(),
};
